import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const mainCategories = categories.filter(c => c.slug !== 'all');

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="text-xl font-bold text-primary-500">{siteInfo.name}</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">{siteInfo.description}</p>
            <div className="flex items-center gap-3 mt-4">
              <a href={siteInfo.socialLinks.weibo} target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href={siteInfo.socialLinks.wechat} target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href={siteInfo.socialLinks.douyin} target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">爆料分类</h4>
            <ul className="space-y-2.5">
              {mainCategories.slice(0, 4).map(cat => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">更多分类</h4>
            <ul className="space-y-2.5">
              {mainCategories.slice(4).map(cat => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-phone-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.phone}
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-map-pin-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.address}
              </li>
            </ul>
            <Link
              to="/about"
              className="inline-flex items-center gap-1 mt-4 text-sm text-primary-400 hover:text-primary-300 transition-colors duration-200"
            >
              了解更多 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} {siteInfo.name} 版权所有 | 本站内容仅供新闻传播，不构成任何投资或行动建议
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <Link to="/about" className="hover:text-foreground-200 transition-colors duration-200">关于我们</Link>
            <span className="text-foreground-600">|</span>
            <span>爆料热线：{siteInfo.phone}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}